import React from 'react';
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  Stack,
  Typography,
  CircularProgress,
  Chip,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from 'dayjs';
import Scrollbar from '../scrollbar';
import { TABLE_HEAD } from '../../utils/leaveConstants';

const LeaveTable = ({
  leaves,
  isLoading,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  onView,
  onEdit,
  onDelete,
}) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Approved':
        return 'success';
      case 'Rejected':
        return 'error';
      case 'Pending':
        return 'warning';
      default:
        return 'default';
    }
  };

  const calculateDays = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    return end.diff(start, 'day') + 1;
  };

  return (
    <Grid item xs={12}>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <TableHead>
                <TableRow>
                  {TABLE_HEAD.map((headCell) => (
                    <TableCell key={headCell.id} align={headCell.alignRight ? 'right' : 'left'}>
                      {headCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={TABLE_HEAD.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : leaves.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={TABLE_HEAD.length} align="center">
                      <Typography variant="body2" color="text.secondary">
                        No employee leaves found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  leaves.map((leave) => (
                    <TableRow hover key={leave.id}>
                      <TableCell>{leave.employee.full_name}</TableCell>
                      <TableCell>{leave.leave_type}</TableCell>
                      <TableCell>{dayjs(leave.start_date).format('MMM DD, YYYY')}</TableCell>
                      <TableCell>{dayjs(leave.end_date).format('MMM DD, YYYY')}</TableCell>
                      <TableCell>{calculateDays(leave.start_date, leave.end_date)}</TableCell>
                      <TableCell>
                        <Chip label={leave.status} color={getStatusColor(leave.status)} size="small" />
                      </TableCell>
                      <TableCell>{leave.reason}</TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1}>
                          <IconButton size="small" onClick={() => onView(leave)}>
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton size="small" onClick={() => onEdit(leave)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton size="small" onClick={() => onDelete(leave)} color="error">
                            <DeleteIcon />
                          </IconButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </Card>
    </Grid>
  );
};

export default LeaveTable;
